module.exports = __webpack_public_path__ + "media/images/icons/screenshot-c72715e1b444d5fd12e105e779251f24.svg";